import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { PageHeader } from '../../components/Layout';

const TenantTransfers = () => {
  return (
    <Box>
      <PageHeader
        title="Room Transfers"
        subtitle="Request or view room transfer history"
        breadcrumbs={[{ label: 'Transfers' }]}
      />
      <Paper sx={{ p: 3 }}>
        <Typography>Room transfers coming soon...</Typography>
      </Paper>
    </Box>
  );
};

export default TenantTransfers;
